module.exports = __webpack_public_path__ + "static/9-ad04d879f8aadecb5334ad45158ef438.png";